export default () => ({
  show: false,

  setZIndex(variable) {
    const header = document.querySelector("#shopify-section-header");
    const rootStyles = getComputedStyle(document.documentElement);
    header.style.zIndex = rootStyles.getPropertyValue(variable).trim();
  },

  close() {
    this.show = false;
    this.setZIndex("--nav-bar-mobile");
  },

  toggle() {
    this.show = !this.show;
    Grebify.noScroll(!this.show);

    if (this.show) {
      this.setZIndex("--nav-bar-mobile");
    } else {
      this.setZIndex("--drawer");
    }
  },
});
